<template>
  <div>
    <div class="row">
      <div class="col">
        <textarea v-model="old" class="w100" rows="20"></textarea>
        <p>Fark:{{ news.split("\n").length>1?old.split("\n").filter(x=>{return news.split("\n").indexOf(x)==-1}).sort((x,y)=>{return x.localeCompare(y)}):"" }}</p>
        <pre>{{ old.split("\n").sort((x,y)=>{return x.localeCompare(y)}) }}</pre>
      </div>
      <div class="col">
        <textarea v-model="news" class="w100" rows="20"></textarea>
        <p>Fark:{{ old.split("\n").length>1?news.split("\n").filter(x=>{return old.split("\n").indexOf(x)==-1}).sort((x,y)=>{return x.localeCompare(y)}):"" }}</p>
        <pre>{{ news.split("\n").sort((x,y)=>{return x.localeCompare(y)}) }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        old:"",
        news:""
      }
    }
  }
</script>

<style>

</style>